import * as Actions from 'app/store/actions';

const initialState = { data: null };

const adminDashboardReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ADMIN_DASHBOARD_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default adminDashboardReducer;
